export default {"src":"/_next/static/media/left-arrow.2c142b80.svg","height":38,"width":37,"blurWidth":0,"blurHeight":0};